import { render, staticRenderFns } from "./GrupoSeparacaoAutocomplete.vue?vue&type=template&id=48df8854&scoped=true"
import script from "./GrupoSeparacaoAutocomplete.vue?vue&type=script&lang=js"
export * from "./GrupoSeparacaoAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df8854",
  null
  
)

export default component.exports